import type { ConfigureStoreOptions } from '@reduxjs/toolkit';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import { appEnvironment, ENVIRONMENT } from 'configs/constants';

import reducer from './rootReducer';

const middleware = [...getDefaultMiddleware()];

const configure = (options: Partial<ConfigureStoreOptions> = {}) =>
  configureStore({
    reducer,
    devTools: appEnvironment !== ENVIRONMENT.Production && { trace: true },
    middleware,
    ...options,
  });

export default configure;
